import React, { createContext, useState, useContext } from 'react';

const UserContext = createContext();

export function UserProvider({ children }) {
  const [user, setUser] = useState({
    username: '',
    user_id: '',
    role: ''
  });

  const updateUser = (userData) => {
    setUser({
      username: userData.username || '',
      user_id: userData.user_id || '',
      role: userData.role || ''
    });
  };

  const clearUser = () => {
    setUser({
      username: '',
      user_id: '',
      role: ''
    });
  };

  return (
    <UserContext.Provider value={{ user, updateUser, clearUser }}>
      {children}
    </UserContext.Provider>
  );
}

export function useUser() {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useUser must be used within a UserProvider');
  }
  return context;
}
